import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "LanguageSwitch" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("img", {
      class: "LanguageSwitch_image",
      src: _ctx.currentLangObj.icon,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLanguageClick && _ctx.handleLanguageClick(...args)))
    }, null, 8, _hoisted_2)
  ]))
}